import { render, staticRenderFns } from "./Ignored.vue?vue&type=template&id=5fc2813e&"
import script from "./Ignored.vue?vue&type=script&lang=js&"
export * from "./Ignored.vue?vue&type=script&lang=js&"
import style0 from "./Ignored.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports